import React from 'react';
import { useCartContext } from '../context/CartContext';
import { removeAttachedServiceOffering } from '../removeAttachedServiceOffering';
import { Portal } from '../../../components/portal/Portal';
import { AttachedService } from '../../../components/cart/AttachedService/AttachedService';
import { parseServiceOffering } from '../drawCartServices';
import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import { ProductGtmData } from '@jbhi-fi/apis/src/algolia/types/ProductGtmData';
import { setCartLoading } from '../../legacyCart';

export const AttachedServices = (): JSX.Element => {
  const { cart, location } = useCartContext();
  const variant = location === 'cart' ? 'wide' : 'narrow';

  return (
    <>
      {cart?.items?.map((lineItem, i) => {
        if (lineItem.properties._isAttachedService !== 'true') return;
        const attachedService = lineItem;
        const container = window.document.getElementById(`attached-${attachedService.properties._serviceLink}`);
        const service = parseServiceOffering(tryParseJson(attachedService.properties?._serviceData) || {});
        const extraCareCoveragePeriod = service?.extraCareCoveragePeriod;
        const serviceLink = attachedService.properties?._serviceLink;
        const lineId = attachedService.line_id;

        if (container && service) {
          const { variantId, googleTagManager } = service;

          const handleRemove = async () => {
            if (variantId) {
              setCartLoading(true);
              await removeAttachedServiceOffering(
                lineId,
                serviceLink,
                googleTagManager,
                location,
                attachedService.isValidService
              );
            }
          };
          return (
            <Portal container={container} key={i}>
              <AttachedService
                offeringName={service.offeringName}
                offeringSku={service.sku}
                offeringType={service.typeId}
                vendorName={service.vendorName}
                priceInc={attachedService.line_price / 100}
                onRemove={handleRemove}
                variant={variant}
                showRemove
                isValid={lineItem.isValidService}
                gtmTrackingData={tryParseJson<ProductGtmData>(lineItem.properties?._gtmProduct || '{}')}
                primaryItem={lineItem}
                extraCareCoveragePeriod={extraCareCoveragePeriod}
                imageUrl={attachedService.image}
                isCartPage
              />
            </Portal>
          );
        }
      })}
    </>
  );
};
